// extracted by mini-css-extract-plugin
export default {"okDialogText":"OkDialog_okDialogText__W2Q44","okButton":"OkDialog_okButton__l60Rh","buttonContainer":"OkDialog_buttonContainer__FguMz"};